export { navigate as CoreNavigate } from '@reach/router';
